import React, { useState, useEffect } from 'react';
import Cadastro from './Cadastro';
import ListaAlunosPopup from './Lista_alunos_popup';
import ConfigPopup from './Config_popup';
import { useNavigate } from 'react-router-dom';
import { getAuth } from "firebase/auth";
import logo from '../images/Logo-square.png';
import AlunoImg from '../images/Tiago.png';
import { User, UserRoundPlus, ChevronDown, List, Settings, LogOut, MoveLeft } from 'lucide-react';
import api, { logout } from '../service/api';
import '../css/Menu.css';

function Menu({ isHome, isAvaliacao, nome, idade, perfil, aluno, dataAvaliacao }) {

    const auth = getAuth();
    const navigate = useNavigate();

    const profileDictionary = {
        homensEMulheresAdultos: "Homens e mulheres adultos",
        mulheresQueDesejamEmagrecer: "Mulheres que desejam emagrecer",
        idosos: "Idosos",
        gestantes: "Gestantes",
        posParto: "Pós-parto",
        obesos: "Obesos",
        diabetesMelitus: "Diabetes Melitus",
        hipertensaoArterial: "Hipertensão arterial",
        depressao: "Depressão"
    };

    const [isCadastroOpen, setCadastroOpen] = useState(false);
    const [isListaAlunosOpen, setListaAlunosOpen] = useState(false);
    const [isConfigOpen, setConfigOpen] = useState(false);
    const [studentList, setStudentList] = useState([]);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false); // CAP-6: overlay de animação ao sair

    const localUserData = localStorage.getItem('@AppAcademia:user');
    const [userData, setUserData] = useState(JSON.parse(localUserData));
    const dataAtual = new Date()

    function formatarData(dataString) {
        const data = new Date(dataString);
        const dia = String(data.getDate()).padStart(2, '0');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        return `${dia}/${mes}/${ano}`;
    }

    const [dataAvaliacaoState, setDataAvaliacaoState] = useState(dataAvaliacao || new Date());
    const [foto, setFoto] = useState('');
    // FIM

    // Popup Cadastro
    const openCadastro = () => {
        setCadastroOpen(true);
    };

    const closeCadastro = () => {
        setCadastroOpen(false);
    };

    // Popup Lista de alunos
    const openListaAlunos = async () => {
        const studentListApiResponse = await handleStudentListLoad();
        setStudentList(studentListApiResponse);
        setListaAlunosOpen(true);
    };

    const handleStudentListLoad = async () => {
        try {
            const response = await api.get('/api/user/students', { withCredentials: true });
            return response.data;
        } catch (err) {
            alert('Erro ao buscar alunos.');
        };
    }

    const closeListaAlunos = () => {
        setListaAlunosOpen(false);
    };

    // Popup Configurações
    const openConfig = async () => {
        setConfigOpen(true);
    };

    const closeConfig = () => {
        setConfigOpen(false);
    };

    const handleBackToHomeAluno = () => {
        if (aluno) {
            navigate('/home-aluno', { state: { alunoSelecionado: aluno } });
        } else {
            navigate('/home');
        }
    };

    const handleLogout = async () => {
        // CAP-6: exibe a animação de saída antes do redirect (logout() faz reload completo).
        setIsLoggingOut(true);
        await auth.signOut();
        // Pequena pausa para a animação ser percebida antes do redirect para '/'.
        setTimeout(() => {
            logout();
        }, 1100);
    };

    return (
        <div className="menu-container">
            {isLoggingOut && (
                <div className="logout-overlay">
                    <div className="logout-overlay-content">
                        <LogOut className="logout-overlay-icon" size={48} />
                        <p>Saindo...</p>
                    </div>
                </div>
            )}
            <div className="gradient-container container-height-5vh"></div>
            <div className="menu-content">
                <div className="menu-itens">
                    <div className="menu-logo-container">
                        {!isAvaliacao ? (
                            <img className="menu-logo" src={userData.photo || logo} alt="Foto do personal" />
                        ) : (
                            <div className="avaliado-info">
                                <div>
                                    <img className="avaliado-img-menu" src={aluno?.foto || AlunoImg} alt="Foto do aluno" />
                                </div>
                                <div className="avaliado-info-container">
                                    <div>
                                        <p><strong>Aluno:</strong> {nome}</p>
                                        <p><strong>Idade:</strong> {idade}</p>
                                    </div>
                                    <div className="avaliado-info-perfil">
                                        <p><strong>Perfil:</strong> {profileDictionary[perfil]}</p>
                                        <p><strong>Data da avaliação:</strong> {formatarData(dataAvaliacaoState)}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="menu-options">
                        {!isAvaliacao ? (
                            <ul className="menu-options-list">
                                {!isHome && (
                                    <li onClick={handleBackToHomeAluno}>
                                        <MoveLeft className="menu-icons" size={20} />
                                        VOLTAR
                                    </li>
                                )}
                                <li onClick={openCadastro}>
                                    <UserRoundPlus className="menu-icons" size={20} />
                                    CADASTRAR ALUNO
                                </li>
                                <li onClick={openListaAlunos}>
                                    <List className="menu-icons" size={20} />
                                    LISTA DE ALUNOS
                                </li>
                                <li
                                    className="user-menu"
                                    onMouseEnter={() => setIsMenuOpen(true)}
                                    onMouseLeave={() => setIsMenuOpen(false)}
                                >
                                    <div className="user-menu-content">
                                        <User className="menu-icons" size={20} />
                                        {userData.name}
                                        <ChevronDown className="menu-icons" size={20} />
                                    </div>

                                    {isMenuOpen && (
                                        <ul className="submenu">
                                            <li onClick={openConfig}>
                                                <Settings className="menu-icons" size={20} />
                                                Configurações
                                            </li>
                                            <li onClick={handleLogout}>
                                                <LogOut className="menu-icons" size={20} />
                                                Sair
                                            </li>
                                        </ul>
                                    )}
                                </li>
                            </ul>
                        ) : (
                            <ul className="menu-options-list">
                                <li onClick={handleBackToHomeAluno}>
                                    <MoveLeft className="menu-icons" size={20} />
                                    VOLTAR
                                </li>
                                <li
                                    className="user-menu"
                                    onMouseEnter={() => setIsMenuOpen(true)}
                                    onMouseLeave={() => setIsMenuOpen(false)}
                                >
                                    <div className="user-menu-content">
                                        <User className="menu-icons" size={20} />
                                        {userData.name}
                                        <ChevronDown className="menu-icons" size={20} />
                                    </div>

                                    {isMenuOpen && (
                                        <ul className="submenu">
                                            <li onClick={openConfig}>
                                                <Settings className="menu-icons" size={20} />
                                                Configurações
                                            </li>
                                            <li onClick={handleLogout}>
                                                <LogOut className="menu-icons" size={20} />
                                                Sair
                                            </li>
                                        </ul>
                                    )}
                                </li>
                            </ul>
                        )}
                    </div>
                </div>
            </div>
            <div className="gradient-container container-height-5px"></div>

            <Cadastro isOpen={isCadastroOpen} onRequestClose={closeCadastro} />
            <ListaAlunosPopup isOpen={isListaAlunosOpen} onRequestClose={closeListaAlunos} studentList={studentList} />
            <ConfigPopup isOpen={isConfigOpen} onRequestClose={closeConfig} userData={userData} setUserData={setUserData} />
        </div>
    );
}

export default Menu;